$(function(){


    $('[js-class-choose-club]').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();


        var $elem = $(this);
        var cssClass = $elem.data('class');
        var cssClassActive = cssClass+'_active';

        if($elem.hasClass(cssClassActive)){
            return;
        }else{
            $elem.siblings().removeClass(cssClassActive).end().addClass(cssClassActive);
        }

        if($elem.data('id') == 'all'){
            $('[js-groups-item]').show();
            $('.groups-toggler__name_active').removeClass('groups-toggler__name_active');
            return;
        }

        $('[js-groups-item]').hide();
        $('[js-class-choose-club-ex]').removeClass('groups-toggler__name_active');

        if($elem.closest('[js-class-choose-club-container]').find('.'+cssClassActive).length){
            var $items = $('[js-groups-item][data-club'+$elem.data('id')+'="1"]');
            $items.each(function(key, item){
                var $item = $(item);

                $item.find('[js-class-choose-club-ex][data-id="'+$elem.data('id')+'"]').addClass('groups-toggler__name_active');
                $item.show();
            });
        }else{
            $('[js-groups-item]').show();
        }

    });

    $('[js-class-choose-club-ex]').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $('[js-class-choose-club][data-id="'+$(this).data('id')+'"]').trigger('click');
    });

});